import { render, staticRenderFns } from "./trapiche.vue?vue&type=template&id=526283c2&scoped=true"
import script from "./trapiche.vue?vue&type=script&lang=js"
export * from "./trapiche.vue?vue&type=script&lang=js"
import style0 from "./trapiche.vue?vue&type=style&index=0&id=526283c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526283c2",
  null
  
)

export default component.exports